import React, { FC } from 'react'

import { EyeOff, Loader2Icon, RotateCcw, Trash } from 'lucide-react'

import { Tooltip, TooltipContent, TooltipTrigger } from '../../../../../../../components/ui/tooltip'

import { IBreakRegistrationByDay } from '../../../../../../../models/events/event.interface'

interface OrderOfGoActionsProps {
  row: IBreakRegistrationByDay
  onClickOrderOfGo: () => Promise<void>
  orderOfGoScratchedLoading?: boolean
  onClickScratch: () => Promise<void>
  onRemoveBreak: () => Promise<void>
  scratchedLoading?: boolean
}

export const OrderOfGoActions: FC<OrderOfGoActionsProps> = ({
  row,
  onClickOrderOfGo,
  orderOfGoScratchedLoading,
  onClickScratch,
  onRemoveBreak,
  scratchedLoading,
}) => {
  return row.orderOfGoScratched ? (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          className="p-0 ml-auto flex border border-none opacity-50 hover:opacity-100 transition-all rounded-lg"
          onClick={onClickOrderOfGo}
        >
          {orderOfGoScratchedLoading ? (
            <Loader2Icon className="w-5 min-w-5 animate-spin" />
          ) : (
            <RotateCcw className="w-5 min-w-5" />
          )}
        </button>
      </TooltipTrigger>
      <TooltipContent>
        <p className="max-w-[200px]">
          Add to the “Order Of Go” table. This means that the “Dropped” status will be removed.
        </p>
      </TooltipContent>
    </Tooltip>
  ) : row.isScratched ? (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          className="flex border-none bg-transparent opacity-50 hover:opacity-100 transition-all"
          onClick={onClickOrderOfGo}
        >
          {orderOfGoScratchedLoading ? (
            <Loader2Icon className="w-5 min-w-5 animate-spin" />
          ) : (
            <EyeOff className="w-5 min-w-5" />
          )}
        </button>
      </TooltipTrigger>
      <TooltipContent>
        <p className="max-w-[200px]">
          Remove from the “Order Of Go” table. This means that will be moved down (dropped).
        </p>
      </TooltipContent>
    </Tooltip>
  ) : (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          className="flex border-none bg-transparent opacity-50 hover:opacity-100 transition-all"
          onClick={async () => {
            if (row.isBreakDrag) await onRemoveBreak()
            else await onClickScratch()
          }}
        >
          {scratchedLoading ? (
            <Loader2Icon className="w-5 min-w-5 animate-spin" />
          ) : (
            <>
              <Trash className="w-5 min-w-5" />
            </>
          )}
        </button>
      </TooltipTrigger>
      <TooltipContent>
        <p className="max-w-[200px]">{row.isBreakDrag ? 'Delete' : 'Scratch'}</p>
      </TooltipContent>
    </Tooltip>
  )
}
